import { AxiosInstance } from "axios";
import { isCancelled } from "helpers";
import { createLogger } from "logging";
import { UserLookupModel } from "models/UserLookupModel";
import { UserModel } from "models/UserModel";

const logger = createLogger("UserApi");

export class UserApi {
  constructor(private axios: AxiosInstance) {}

  private apiSearchUsersController: AbortController | undefined;

  async getProfileImage(profileImage: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.axios
        .get(profileImage, { responseType: "blob", allowAbsoluteUrls: true })
        .then((response) => {
          const fileReader = new FileReader();
          fileReader.onload = (e) => {
            const result = e.target?.result;
            const s = result === "data:" ? "" : (result as string);
            logger.trace(`loaded ${profileImage} ${s?.substring(0, 40)} (${s.length} bytes)...`);
            resolve(s);
          };
          fileReader.readAsDataURL(response.data);
        })
        .catch((error) => {
          logger.warn("failed to load", profileImage, error);
          reject(error);
        });
    });
  }

  async getUser(id: string): Promise<UserModel> {
    try {
      const response = await this.axios.get<UserModel>(`/api/users/${id}`);
      return response.data;
    } catch (error) {
      logger.error("Failed to get user", error);
      throw error;
    }
  }

  async searchUsers(searchCriteria: string): Promise<UserLookupModel[]> {
    try {
      this.apiSearchUsersController?.abort();
      this.apiSearchUsersController = new AbortController();
      const requestConfig = {
        signal: this.apiSearchUsersController.signal,
      };

      const response = await this.axios.get<UserLookupModel[]>(`/api/users/search?q=${searchCriteria}`, requestConfig);
      this.apiSearchUsersController = undefined;

      return response.data;
    } catch (error) {
      if (isCancelled(error)) {
        return [];
      }

      logger.error("Failed to search users", error);
      throw error;
    }
  }
}
